export const ctaTextBlock = `
_type in ["ctaTextBlock", "ctaBlock"] => {
  "btn_label": btn_label[_key == $lang][0].value,
  btn_link {
    ...,
    internalLink->{ _type, "uid": uid[_key == $lang][0].value, context, },
  },
}
`
